/** Admin guide §7 — Questionnaire (`admin/QuestionnaireTab.tsx`, Settings → Questionnaire). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, Shot } from '../HelpPrimitives.js';

export function AdminQuestionnaire(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-questionnaire')}>
      <Shot
        slug="admin-questionnaire"
        caption="The base Kick-off question list, grouped by category."
      />
      <P>
        The base set of questions every recruiter answers during a Kick-off meeting, grouped by
        category. Click <Btn>Add question</Btn> to add one, or hover a row to edit or delete it.
      </P>
      <Bullets>
        <Li>
          <Btn>Category</Btn> and <Btn>Question text</Btn> are required.
        </Li>
        <Li>
          <Btn>AI instruction</Btn> — optional extra guidance for the AI when it fills this question
          in via Pre-fill or the meeting transcript. A question with one shows a small hint badge;
          hover it to read the instruction.
        </Li>
        <Li>
          <Btn>Sort order</Btn> controls where the question falls within its category.
        </Li>
      </Bullets>
      <Callout title="Deleting a question is immediate">
        <P>There is no confirmation step before a row&rsquo;s delete takes effect.</P>
      </Callout>
    </HelpSectionCard>
  );
}
